import { StyleProp, TextStyle, ViewStyle } from 'react-native'
import { Switch } from 'react-native-paper'

import UniText from '@/components/unistyles/UniText'
import UniTouchableRipple from '@/components/unistyles/UniTouchableRipple'
import { BasicFiltersSlice } from '@/store/basicFilterSlice'
import { useAppStore } from '@/store/useAppStore'

type BasicFilter = BasicFiltersSlice['basicFilters']['filters']
type BooleanFilterKeys = {
  [K in keyof BasicFilter]: BasicFilter[K] extends boolean ? K : never
}[keyof BasicFilter]

interface Props {
  filter: BooleanFilterKeys
  label: string
  style?: StyleProp<ViewStyle>
  textStyle?: StyleProp<TextStyle>
}

const GridFilterBasicSwitch = ({ filter, label, style, textStyle }: Props) => {
  const basicFilters = useAppStore.use.basicFilters()
  const setBasicFilters = useAppStore.use.setBasicFilters()

  const handleToggle = () => {
    setBasicFilters({
      ...basicFilters,
      filters: {
        ...basicFilters.filters,
        [filter]: !basicFilters.filters[filter],
      },
    })
  }

  return (
    <UniTouchableRipple
      accessibilityRole="button"
      borderless
      onPress={handleToggle}
      style={style}
      testID={`${filter}-grid-filter-pressable`}
    >
      <>
        <UniText style={textStyle}>{label}</UniText>
        <Switch
          onValueChange={handleToggle}
          role="checkbox"
          testID={`${filter}-grid-filter-switch`}
          value={basicFilters.filters[filter]}
        />
      </>
    </UniTouchableRipple>
  )
}

export default GridFilterBasicSwitch
